import React from 'react';
import { Box, Chip, Tooltip, IconButton } from '@mui/material';
import { HealthAndSafety, Warning, Error, Refresh } from '@mui/icons-material';
import { useWarmup } from '../../contexts/WarmupContext';

const SystemHealthIndicator: React.FC = () => {
    const { systemHealth, resetWarmup } = useWarmup();

    if (!systemHealth) {
        return null;
    }

    const getStatusIcon = () => {
        switch (systemHealth.overall) {
            case 'healthy':
                return <HealthAndSafety sx={{ fontSize: 16 }} />;
            case 'degraded':
                return <Warning sx={{ fontSize: 16 }} />;
            case 'unhealthy':
                return <Error sx={{ fontSize: 16 }} />;
            default:
                return <HealthAndSafety sx={{ fontSize: 16 }} />;
        }
    };

    const getStatusColor = () => {
        switch (systemHealth.overall) {
            case 'healthy':
                return 'success';
            case 'degraded':
                return 'warning';
            case 'unhealthy':
                return 'error';
            default:
                return 'default';
        }
    };

    const getTooltipContent = () => {
        const readyServices = systemHealth.services.filter(s => s.status === 'ready').length;
        const totalServices = systemHealth.services.length;
        
        return (
            <div>
                <div><strong>System Status:</strong> {systemHealth.overall}</div>
                <div><strong>Services:</strong> {readyServices}/{totalServices} ready</div>
                <div><strong>Last Check:</strong> {new Date(systemHealth.timestamp).toLocaleTimeString()}</div>
                <br />
                <div style={{ fontSize: '0.75em' }}>
                    {systemHealth.services.map(service => (
                        <div key={service.service}>
                            {service.service}: {service.status} ({service.responseTimeMs}ms)
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title={getTooltipContent()} arrow>
                <Chip
                    icon={getStatusIcon()}
                    label={`${systemHealth.overall}`}
                    color={getStatusColor() as any}
                    size="small"
                    variant="outlined"
                />
            </Tooltip>
            <Tooltip title="Refresh system health">
                <IconButton 
                    size="small" 
                    onClick={resetWarmup}
                    sx={{ ml: 0.5 }}
                >
                    <Refresh fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default SystemHealthIndicator;
